var map = {
	"./about-us-banner-cn.webp": 1550,
	"./about-us-banner-m-cn.webp": 1551,
	"./about-us-banner-m-ms.webp": 1552,
	"./about-us-banner-m.webp": 1553,
	"./about-us-banner-ms.webp": 1554,
	"./about-us-banner.webp": 462,
	"./banner-01.jpg": 1555,
	"./banner-slot.jpg": 1556,
	"./bet-and-earn-banner-cn.webp": 1557,
	"./bet-and-earn-banner-indon.webp": 1558,
	"./bet-and-earn-banner-ms.webp": 1559,
	"./bet-and-earn-banner.webp": 1560,
	"./check-in-banner-cn.webp": 1561,
	"./check-in-banner-id.webp": 1562,
	"./check-in-banner-ms.webp": 1563,
	"./check-in-banner.webp": 1564,
	"./cny_2024-bm.webp": 1565,
	"./cny_2024-cn.webp": 1566,
	"./cny_2024.webp": 1567,
	"./epl-banner-cn.webp": 1568,
	"./epl-banner-indo.webp": 1569,
	"./epl-banner-ms.webp": 1570,
	"./epl-banner.webp": 1571,
	"./games-banners-cn.webp": 1572,
	"./games-banners-ms.webp": 1573,
	"./games-banners.webp": 1574,
	"./lb-m-banner-cn.webp": 1575,
	"./lb-m-banner.webp": 1576,
	"./leaderboard-banner-cn.webp": 1577,
	"./leaderboard-banner.webp": 1578,
	"./lottery-banner.webp": 1579,
	"./lottery-banners-cn.webp": 1580,
	"./lottery-banners-ms.webp": 1581,
	"./lottery-banners.webp": 1582,
	"./lucky-spin-banner-cn.webp": 1583,
	"./lucky-spin-banner-ms.webp": 1584,
	"./lucky-spin-banner.webp": 1585,
	"./p2p-banner.webp": 1586,
	"./p2p-banners-cn.webp": 1587,
	"./p2p-banners-ms.webp": 1588,
	"./p2p-banners.webp": 1589,
	"./premier-league-banner-cn.webp": 1590,
	"./premier-league-banner.webp": 1591,
	"./promo-vip-banner-cn.webp": 1592,
	"./promo-vip-banner-ms.webp": 1593,
	"./promo-vip-banner.webp": 1594,
	"./promos-banner-cn.webp": 1595,
	"./promos-banner-indon.webp": 1596,
	"./promos-banner-ms.webp": 1597,
	"./promos-banner.webp": 1598,
	"./promos-detail-banner.jpg": 1599,
	"./side-bar-banner.jpg": 1600,
	"./slot-banners-cn.webp": 1601,
	"./slot-banners-ms.webp": 1602,
	"./slot-banners.webp": 1603,
	"./speed-banners-cn.webp": 1604,
	"./speed-banners-ms.webp": 1605,
	"./speed-banners.webp": 1606,
	"./vip-banner-cn.webp": 1607,
	"./vip-banner-id.webp": 1608,
	"./vip-banner-m-cn.webp": 1609,
	"./vip-banner-m-ms.webp": 1610,
	"./vip-banner-m.webp": 1611,
	"./vip-banner-ms.webp": 1612,
	"./vip-banner.webp": 1613,
	"./vip-deposit-marathon-challenges-cn.webp": 1614,
	"./vip-deposit-marathon-challenges-ms.webp": 1615,
	"./vip-deposit-marathon-challenges.webp": 1616,
	"./winner-leaderboard-banner-cn.webp": 1617,
	"./winner-leaderboard-banner.webp": 1618,
	"./world-cup-banner-cn.webp": 1619,
	"./world-cup-banner.webp": 1620,
	"./world-cup-two-banner-cn.webp": 1621,
	"./world-cup-two-banner.webp": 1622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;